export default "__VITE_ASSET__qY33OIUV__"